'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002etemporal$002e$002dChrono$002dField from "./java.time.temporal.-Chrono-Field.js";
import * as $j_java$002etime$002etemporal$002e$002dChrono$002dUnit from "./java.time.temporal.-Chrono-Unit.js";
var $p;
/** @constructor */
function $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(relative, dayOfWeek) {
  this.zP = 0;
  this.vr = 0;
  this.zP = relative;
  this.vr = dayOfWeek.gx();
}
export { $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek as $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek };
$p = $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek;
/** @constructor */
function $h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek() {
}
export { $h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek as $h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek };
$h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype = $p;
$p.he = (function(temporal) {
  var calDow = temporal.cC($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  if (((this.zP < 2) && (calDow === this.vr))) {
    return temporal;
  } else if (((1 & this.zP) === 0)) {
    var daysDiff = ((calDow - this.vr) | 0);
    if ((daysDiff >= 0)) {
      var hi = (daysDiff >> 31);
      var lo = ((7 - daysDiff) | 0);
      var hi$1 = ((((-hi) | 0) - (((lo >>> 0) > 7) | 0)) | 0);
      var $x_1_$_lo = lo;
      var $x_1_$_hi = hi$1;
    } else {
      var hi$2 = (daysDiff >> 31);
      var lo$1 = ((-daysDiff) | 0);
      var hi$3 = ((((-hi$2) | 0) - ((lo$1 !== 0) | 0)) | 0);
      var $x_1_$_lo = lo$1;
      var $x_1_$_hi = hi$3;
    }
    return temporal.is($x_1_$_lo, $x_1_$_hi, $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit());
  } else {
    var daysDiff$2 = ((this.vr - calDow) | 0);
    if ((daysDiff$2 >= 0)) {
      var hi$4 = (daysDiff$2 >> 31);
      var lo$2 = ((7 - daysDiff$2) | 0);
      var hi$5 = ((((-hi$4) | 0) - (((lo$2 >>> 0) > 7) | 0)) | 0);
      var $x_2_$_lo = lo$2;
      var $x_2_$_hi = hi$5;
    } else {
      var hi$6 = (daysDiff$2 >> 31);
      var lo$3 = ((-daysDiff$2) | 0);
      var hi$7 = ((((-hi$6) | 0) - ((lo$3 !== 0) | 0)) | 0);
      var $x_2_$_lo = lo$3;
      var $x_2_$_hi = hi$7;
    }
    return temporal.uj($x_2_$_lo, $x_2_$_hi, $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit());
  }
});
var $d_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek, "java.time.temporal.TemporalAdjusters$RelativeDayOfWeek", ({
  mz: 1,
  I: 1
}));
export { $d_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek as $d_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek };
